const BRANDED_FARE_CATEGORIES = ["ApiPartner", "B2C"] as const;

const CATEGORY_LABELS: Record<string, string> = {
  ApiPartner: "API",
  Allotment: "Allotment",
  B2C: "B2C",
  Gos: "GOS",
  StaffTravel: "Staff"
};

const supportsBrandedFare = (bookingCategory?: string | null): boolean => {
  return !!bookingCategory && BRANDED_FARE_CATEGORIES.includes(bookingCategory as typeof BRANDED_FARE_CATEGORIES[number]);
};

const getBookingCategoryLabel = (bookingCategory?: string | null): string => {
  if (!bookingCategory) {
    return "";
  }

  return CATEGORY_LABELS[bookingCategory] ?? bookingCategory;
};

export { supportsBrandedFare, getBookingCategoryLabel };